import { useGraphQLQuery } from '@betterment/graphql';
import {
  ActiveIraContributionsAndMatchGrantsByYearQueryResult,
  IraContributionMatchGrants,
  IraContributionYears,
  MessagesResult,
} from '@betterment/shared-components/src/components/ira-contributions/data';

import { ActiveIraContributionsAndMatchGrantsByYearDocument } from './graphql/query.ActiveIraContributionsAndMatchGrantsByYear.generated';

export const useActiveIraContributionsAndMatchGrantsByYearQuery =
  (): ActiveIraContributionsAndMatchGrantsByYearQueryResult => {
    const { data } = useGraphQLQuery(ActiveIraContributionsAndMatchGrantsByYearDocument, { throwOnError: true });

    const isLoading = !data;

    return {
      isLoading,
      iraContributions: data?.iraContributions?.byYear as IraContributionYears | undefined,
      iraContributionMatchGrants: data?.iraContributionMatchGrants as IraContributionMatchGrants | undefined,
      messages: data?.messages as MessagesResult | null | undefined,
    };
  };
